import AjaxModal from "../classes/ajax_modal";
import confetti from "canvas-confetti";

var toasts = []; // Total amount of toasts on the screen.

export const initializeModals = (scope) => {
  const modalTriggers = scope.querySelectorAll("[data-js='ajax-modal']");

  modalTriggers.forEach((modalTrigger) => {
    modalTrigger.addEventListener("click", (e) => {
      e.preventDefault();

      new AjaxModal(modalTrigger);
    });
  });
};

export const displayNotification = (message, element, { type = "error", placement = "innerHTML", inline = false }) => {
  let notificationElement = inline
    ? `<div class="input-notice input-${type} mt-1">${message}</div>`
    : `<div class="info info-${type} my-5 w-100"><i class="icon icon-${type}"></i><div>${message}</div></div>`;

  if (placement != "innerHTML") {
    element.insertAdjacentHTML(placement, notificationElement);
  } else {
    element.innerHTML = notificationElement;
  }
};

export const displayFormErrors = (form, errors) => {
  let errorsArray = Object.entries(errors);

  // We remove all existing error messages and classes
  form.querySelectorAll(".input-validation-error").forEach((errorElement) => {
    errorElement.classList.remove("input-validation-error");
    errorElement.nextElementSibling.remove();
  });

  errorsArray.forEach((error) => {
    const [inputName, errorMessages] = error;
    let errorElement;

    // We loop through all input types to find the element
    errorElement = document.getElementById(inputName);

    if (!errorElement) {
      throw new Error(`Element with id ${inputName} not found`);
    }

    errorElement.classList.add("input-validation-error");

    let classes = "error-message";

    if (errorElement.type === "radio" || errorElement.type === "checkbox") {
      classes += " checkbox-error";
    }

    errorElement.insertAdjacentHTML("afterend", `<span class="${classes}">${errorMessages.join(", ")}</span>`);

    errorElement.addEventListener(
      "change",
      () => {
        errorElement.classList.remove("input-validation-error");
        errorElement.nextElementSibling.remove();
      },
      {
        once: true,
      }
    );
  });
};

export const validatedDate = (date) => {
  if (date === "") {
    return false;
  }

  let formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    return formattedDate;
  }
  return false;
};

export const fillAvatarBg = (number) => {
  switch (number) {
    case 1:
    case 2:
      return "var(--bs-primary)";
    case 3:
    case 4:
      return "var(--bs-secondary)";
    case 5:
    case 6:
      return "var(--bs-blue-dark)";
    case 7:
    case 8:
      return "var(--bs-purple-dark)";
    default:
      return "var(--bs-success-900)";
  }
};

export const fillColorByDepth = (depth) => {
  switch (depth) {
    case 1:
      return "var(--bs-green-900)";
    case 2:
      return "var(--bs-purple-dark)";
    case 3:
      return "var(--bs-blue-dark)";
    case 4:
      return "var(--bs-moss)";
    case 5:
      return "var(--bs-pink)";
    case 6:
      return "var(--bs-red-dark)";
    default:
      return "var(--bs-primary)";
  }
};

export const displayToast = (message, type = "error") => {
  let element = document.querySelector("[data-js='toast']");

  if (!element) {
    const toastElement = document.createElement("div");
    toastElement.className = "toast-container p-3 bottom-0 end-0 position-fixed";
    toastElement.setAttribute("data-js", "toast");
    document.body.appendChild(toastElement);
    element = document.querySelector("[data-js='toast']");
  }

  let ariaLive;
  let ariaRole;

  if (type === "error") {
    ariaRole = "alert";
    ariaLive = "assertive";
  } else {
    ariaRole = "status";
    ariaLive = "polite";
  }

  const elementId = Date.now().toString();

  let notificationElement = `
    <div id="${elementId}" class="toast" role="${ariaRole}" aria-live="${ariaLive}" aria-atomic="true">
    <div class="info info-${type}">
      <i class="icon icon-${type}"></i>
      <div>${message}</div>
    </div>
  </div>
  `;

  element.insertAdjacentHTML("afterBegin", notificationElement);

  const toast = document.getElementById(elementId);

  // We wait a little for the element to be fully loaded into the DOM.
  toasts.push(toast);

  if (toasts.length > 2) {
    const toastToRemove = toasts.shift();

    toastToRemove.classList.add("disappear-anim");

    setTimeout(() => {
      toastToRemove.remove();
    }, 250);
  }

  setTimeout(() => {
    toasts.forEach((toastInArr, index) => {
      if (toast === toastInArr) {
        return;
      }

      toastInArr.style.bottom = toast.offsetHeight + 16 * (index + 1) * 2 + "px";
    });
    toast.classList.add("show");
  }, 25);

  setTimeout(() => {
    toast.classList.add("disappear-anim");
    setTimeout(() => {
      let toastIndex = toasts.indexOf(toast);
      toast.remove();

      if (toastIndex > -1) {
        toasts.splice(toastIndex, 1);
      }
    }, 200);
  }, 3500);
};

export const sendAppsignalError = (errorMessage, className, responseInstance) => {
  const span = window.Appsignal.createSpan();

  span.setNamespace("frontend");
  span.setAction(className);
  span.setError(errorMessage);

  if (responseInstance.response) {
    span.setParams(classToObject(responseInstance.response));
  }

  window.Appsignal.send(span);
};

const keys = (x) => Object.getOwnPropertyNames(x).concat(Object.getOwnPropertyNames(x?.__proto__));
const isObject = (v) => Object.prototype.toString.call(v) === "[object Object]";

// This function is used to convert a class to an object.
const classToObject = (clss) => {
  keys(clss ?? {}).reduce((object, key) => {
    const [val, arr, obj] = [clss[key], Array.isArray(clss[key]), isObject(clss[key])];
    object[key] = arr ? val.map(classToObject) : obj ? classToObject(val) : val;
    return object;
  }, {});
};

export const displaySessionExpiredModal = () => {
  const existingSessionModal = document.getElementById("session-expired-modal");
  if (existingSessionModal) {
    return;
  }

  new AjaxModal(document.body);
};

export const toRegExp = (string) => {
  if (string === "") return "";

  const [, ...parts] = string.match(/^\/((?:\\.|[^\\])*)\/(.*)$/) ?? [, string];
  try {
    return RegExp(...parts);
  } catch (error) {
    return error; // Could for instance be an error about invalid flags
  }
};

export const displayConfetti = (canvasTarget, options = {}) => {
  const crescent = confetti.shapeFromPath({
    path: "M0.665555 9.41054C0.187262 9.68669 0.0193159 10.302 0.343704 10.749C0.88578 11.4959 1.53381 12.1622 2.26876 12.7262C3.26873 13.4935 4.41004 14.0563 5.62752 14.3825C6.84501 14.7087 8.11482 14.792 9.36447 14.6275C10.6141 14.4629 11.8191 14.0539 12.9107 13.4237C14.0023 12.7935 14.959 11.9544 15.7263 10.9544C16.4936 9.95447 17.0565 8.81316 17.3827 7.59568C17.7089 6.37819 17.7921 5.10838 17.6276 3.85873C17.5067 2.94026 17.2537 2.04591 16.8779 1.20299C16.653 0.698574 16.0361 0.536358 15.5578 0.8125L12.436 2.61487C11.9577 2.89102 11.8079 3.50235 11.9569 4.03416C12.0079 4.2162 12.046 4.40203 12.0708 4.59029C12.1393 5.11021 12.1046 5.63853 11.9689 6.14506C11.8332 6.6516 11.599 7.12645 11.2798 7.54249C10.9605 7.95853 10.5625 8.30762 10.1083 8.56982C9.65418 8.83203 9.15283 9.00221 8.63291 9.07066C8.11299 9.13911 7.58468 9.10448 7.07814 8.96876C6.5716 8.83303 6.09675 8.59886 5.68071 8.27962C5.53006 8.16402 5.38819 8.03809 5.25604 7.9029C4.86999 7.50796 4.26565 7.33203 3.78735 7.60817L0.665555 9.41054Z",
  });

  const smallRectangle = confetti.shapeFromPath({
    path: "M0 7.64V1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447714 7 0.999999V7.64C7 8.19229 6.55228 8.64 6 8.64H1C0.447715 8.64 0 8.19229 0 7.64Z",
  });

  const bigRectangle = confetti.shapeFromPath({
    path: "M0 17.2V1C0 0.447715 0.447715 0 1 0H6C6.55228 0 7 0.447714 7 0.999999V17.2C7 17.7523 6.55228 18.2 6 18.2H1C0.447715 18.2 0 17.7523 0 17.2Z",
  });

  const canvasElement = document.createElement("canvas");
  canvasTarget.insertBefore(canvasElement, canvasTarget.firstChild);
  canvasElement.classList.add("confetti-canvas");

  const myConfetti = confetti.create(canvasElement, {
    resize: true,
  });

  myConfetti({
    disableForReducedMotion: true,
    shapes: ["circle", crescent, smallRectangle, bigRectangle],
    colors: ["#EB09D4", "#EB6209", "#DCE9C4", "#09B5EB", "#116A80", "#6B2577", "#6B4926", "#657F71"],
    ...options,
  }).then(() => {
    canvasElement.remove();
  });
};
